import { IChatServerService } from '@/app-modules/server-service';
import { IUserSearchResult } from '@/components/chat/_domain/modules/user-search-service/user-search-result';
import { generateGuid } from '@/helper';

class UserSearchRequest {
  public readonly requestToken: string = generateGuid();
  private searchResultList: IUserSearchResult[] = [];

  constructor(public readonly username: string, private readonly resolveCallback: () => void) {
  }

  public send(server: IChatServerService): void {
    server.send(this.getAdminCommand());
  }

  public resolve(searchResults: IUserSearchResult[]): void {
    this.searchResultList = searchResults;
    this.resolveCallback();
  }

  public get searchResults(): IUserSearchResult[] {
    return this.searchResultList;
  }

  private getAdminCommand(): { toPayload: () => string } {
    const { username, requestToken } = this;
    return {
      toPayload() {
          return `<admin command="finduser" username="${username}" token="${requestToken}" />`;
      }
    };
  }
}

export { UserSearchRequest };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/user-search-service/user-search-request.ts